export default "__VITE_ASSET__CJiKWvz5__"